import User from './user';

export default class DataConnector extends User {
    static exportFilters = {
        isActive: false,
        enabled: true,
        roleNames: ['connector']
    }
    static moduleName = 'dataConnectors';
}